import { render, staticRenderFns } from "./VideoM3u8Demo.vue?vue&type=template&id=08a4840b&scoped=true&"
import script from "./VideoM3u8Demo.vue?vue&type=script&lang=ts&"
export * from "./VideoM3u8Demo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a4840b",
  null
  
)

export default component.exports